import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme>(theme => ({
  changeRoleTitle: {
    marginBottom: theme.spacing(4)
  },
  roleButton: {
    marginBottom: theme.spacing(2),
    width: '389px'
  }
}));

export default createClasses;
